import {
  React,
  Link,
  Select,
  Divider,
  Switch,
  ScreenWisePostScheduling,
  PlayCircleOutlineIcon,
  useGetAllScreenPostsMutation,
  useUpdateScreenWisePostStatusMutation,
  useRefreshScreenMutation,
  useDeletePostMutation,
  useChangePostOrderMutation,
  PostPlaying,
  EditIcon,
  MoreVertIcon,
  useNavigate,
  alpha,
  Menu,
  MenuItem,
  DeleteForeverIcon,
  useEffect,
  memo,
  useCallback,
  useLocation,
  Button,
  toast,
  useState,
  LoadingSpinner,
  Grid,
  Paper,
  Box,
  Add,
  styled,
  swal,
  useGetAllScreensMutation,
  Empty,
  Modal,
  GetCookie,
  useAddMediatoAsOfflineMutation
} from "../../../Libraries/Post/GetAllPostRelatedToScreen/AllPosts/index";
import {
  FormControl,
  FormGroup,
  FormControlLabel,
  RadioGroup,
  Radio,
} from "../../../Libraries/Post/Customization/index";

import { IconButton } from "@mui/material";
import {
  useCreatePostForSingleScreenMutation,
  useGetAllMediaOfCurrentScreenMutation,
  useChangeMediaOrderMutation,
  useUpdateMediaDurationMutation,
  useUpdatePostStatusInScreenMutation,
  useDeleteMediaMutation,
  useGetSelectiveNewsMutation,
  useGetRSSNewsMutation,
} from "../../../Redux/service/AllEmpData";
import {
  Dialog,
  ChooseMedia,
} from "../../../Libraries/Post/AddNewPost/Child/AddPostMiddleForm/index";
import ImageLazyLoading from "../../../components/ImageLazyLoad/ImageLazyLoading";
import EditChooseMedia from "../../../components/EditPost/ChooseMedia/EditChooseMedia";
import AvTimerIcon from "@mui/icons-material/AvTimer";
import AccessTimeFilledIcon from "@mui/icons-material/AccessTimeFilled";
import DeleteIcon from "@mui/icons-material/Delete";
import { red } from "@mui/material/colors";
import {
  useUpdateScreenFooterOptionMutation,
} from "../../../Redux/service/AllEmpData";
import Marquee from "react-fast-marquee";
import add_media_image from "../../../Assets/svgs/add_media_image.svg";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "transparent",
  ...theme.typography.body2,
  padding: theme.spacing(0),
  textAlign: "start",
  color: theme.palette.text.secondary,
  borderRadius: theme.spacing(0),
  boxShadow: "none",
}));

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color:
      theme.palette.mode === "light"
        ? "rgb(55, 65, 81)"
        : theme.palette.grey[300],
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      "&:active": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        ),
      },
    },
  },
}));

const NewScreenMediaMapping = () => {
  const location = useLocation();

  const [openAddpostDialog, setOpenAddPostDialog] = useState(false);
  const navigate = useNavigate();

  const [createPostForSingleScreen] = useCreatePostForSingleScreenMutation();

  const [deletePost, { isLoading: deleteloading }] = useDeletePostMutation();
  const [refreshScreen] = useRefreshScreenMutation();

  const [deleteMedia] = useDeleteMediaMutation();
  const [getAllPostRelatedToTheScreen, { isLoading }] =
    useGetAllScreenPostsMutation();
  const [getAllScreensfromdb, { isLoading: loading }] =
    useGetAllScreensMutation();

  const [updateScreenFooterOption] = useUpdateScreenFooterOptionMutation();

  const [getSelectiveNews] = useGetSelectiveNewsMutation();

  const [getRSSNews] = useGetRSSNewsMutation();

  const [updateMediaDuration] = useUpdateMediaDurationMutation();
  const [Loading, setLoading] = useState(true);

  const [getAllMediaOfCurrentScreenFromDB, { isLoading: loading1 }] =
    useGetAllMediaOfCurrentScreenMutation();

  const [ChangeOrder, { isLoading: changeorderloading }] =
    useChangeMediaOrderMutation();
  const [screenPostStatusChange, { isLoading: screenwisePostStatusloading }] =
    useUpdatePostStatusInScreenMutation();
  const [addMediatoAsOffline, { isLoading: loading2 }] =
    useAddMediatoAsOfflineMutation();
  const [marqueeText, setMarqueeText] = useState([]);
  const durationOptions = [
    { value: "30000", label: "30 seconds" },
    { value: "60000", label: "1 minute" },
    { value: "120000", label: "2 minute" },
  ];

  const [showRefershScreen, setShowRefreshScreen] = useState(false);
  const [footerRssLink, setFooterRssLink] = useState("");
  const [footerText, setFooterText] = useState("");
  const [options, setoptions] = useState([]);
  const [mediaForCurrentScreen, setMediaForCurrentScreen] = useState(null);
  const [defaultScreen, setDefaultScreen] = useState(location?.state);
  const [currentScreen, setCurrentScreen] = useState(location?.state);

  const [allposts, setallposts] = useState();
  const [orders, setorders] = useState();
  const [totalduration, settotalduration] = useState();
  const [openLiveView, setOpenLiveView] = useState(false);

  const [clickedPost, setclickedPost] = useState();
  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);
  const [footerKey, setFooterKey] = useState("none");
  const [data, setdata] = useState({
    playingpost: false,
    selectedpost: null,
    screenwisePostStatuscomponent: false,
  });

  const [postData, setPostdata] = useState({
    selectedLayout: location.state?.ser_layout_id
      ? location.state?.ser_layout_id
      : "1",
    selectedScreens: location.state?.screens
      ? location.state.screens
      : location.state?.track
      ? location.state
      : [],
    PostStatus: location.state?.txt_post_status
      ? location.state?.txt_post_status
      : "false",
    PostTitle: location.state?.txt_post_title
      ? location.state?.txt_post_title
      : "",
    finalfile: location.state?.finalfile ? location.state.finalfile : null,
    selectedDuration: location.state?.txt_post_duration
      ? location.state?.txt_post_duration
      : [],
    radiobuttonvalue: "Day wise",
  });

  const handleClose = () => {
    setAnchorEl(null);
  };

  const getMediaOfCurrentScreen = useCallback(async () => {
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append(
        "txt_customer_id",
        localStorage.getItem("txt_customer_id")
      );
      formData.append("security_token", await GetCookie("es_token"));
      formData.append("ser_screen_id", currentScreen[0].value);

      const returned = await getAllMediaOfCurrentScreenFromDB(
        formData
      ).unwrap();

      if (
        returned.status === "true" &&
        returned.connection === "true" &&
        returned.message === "Posts available"
      ) {
        setMediaForCurrentScreen(returned.data);

        setoptions(returned.orders);
      } else if (
        returned.status === "false" &&
        returned.connection === "true" &&
        returned.message === "No Posts available"
      ) {
        setMediaForCurrentScreen(null);
      } else {
        toast.info(returned.message);
      }
    } catch (error) {
      toast.error(error.error);
      console.error(error);
    } finally {
      setLoading(false);
    }
  }, [getAllMediaOfCurrentScreenFromDB]);

  const handleUpdateScreenFooterOption = useCallback(
    async (screenParams, rssLink, text) => {
      try {
        setShowRefreshScreen(true);
        const formData = new FormData();
        formData.append("footer_option", screenParams);

        if (screenParams !== null && screenParams === "RSS") {
          formData.append("footer_value", rssLink);
          setFooterText("");
        } else if (screenParams !== null && screenParams === "Text") {
          formData.append("footer_value", text);
          setFooterRssLink("");
        } else {
          formData.append("footer_value", "N/A");
        }

        formData.append(
          "txt_customer_id",
          localStorage.getItem("txt_customer_id")
        );
        formData.append("security_token", await GetCookie("es_token"));
        formData.append("ser_screen_id", currentScreen[0].value);

        const returned = await updateScreenFooterOption(formData).unwrap();

        if (
          returned.status === "true" &&
          returned.connection === "true" &&
          returned.message === "Footer updated successfully"
        ) {

          var temp = [...currentScreen]; // Shallow copy

          const deepCopy = JSON.parse(JSON.stringify(temp[0])); // Deep copy

          deepCopy.footer_option = screenParams;
          if (screenParams !== null && screenParams === "RSS") {
            deepCopy.footer_value = rssLink;
          } else if (screenParams !== null && screenParams === "Text") {
            deepCopy.footer_value = text;
          }
          temp[0] = deepCopy;
          setCurrentScreen([...temp]);
          toast.success(returned.message);
        } else {
          toast.info(returned.message);
        }
      } catch (error) {
        toast.error(error.error);
        console.error(error);
      }
    },
    []
  ); 
  const getAllPosts = useCallback(
    async (screen) => {
      var jsonObj = {
        txt_customer_id: localStorage.getItem("txt_customer_id"),
        security_token: await GetCookie("es_token"),
        screens: JSON.stringify(
          screen?.map((scrn) => ({ ser_screen_id: scrn.value }))
        ),
      };
      try {
        const returned = await getAllPostRelatedToTheScreen(jsonObj).unwrap();
        if (
          returned.status === "true" &&
          returned.connection === "true" &&
          returned.message === "Posts available"
        ) {
          setallposts(returned.data);
          setorders(returned.orders);
          settotalduration(returned.total_duration_of_playlist);
        } else {
          setallposts([]);
        }
      } catch (error) {
        console.log(error);
        toast.error(error.error);
      }
    },
    [getAllPostRelatedToTheScreen]
  );
  useEffect(() => {
    getMediaOfCurrentScreen();
    getFooterValue();
  }, [getMediaOfCurrentScreen]);

  const getFooterValue = () => {
    if (location?.state[0].footer_option === "News") {
      setDefaultScreen((prevDefaultScreen) =>
        prevDefaultScreen.map((item, itemIndex) =>
          itemIndex === 0 ? { ...item, footer_option: "News" } : item
        )
      );
    } else if (location?.state[0].footer_option === "Cricinfo") {
      setDefaultScreen((prevDefaultScreen) =>
        prevDefaultScreen.map((item, itemIndex) =>
          itemIndex === 0 ? { ...item, footer_option: "Cricinfo" } : item
        )
      );
    } else if (location?.state[0].footer_option === "English News") {
      setDefaultScreen((prevDefaultScreen) =>
        prevDefaultScreen.map((item, itemIndex) =>
          itemIndex === 0 ? { ...item, footer_option: "English News" } : item
        )
      );
    } else if (location?.state[0].footer_option === "Urdu News") {
      setDefaultScreen((prevDefaultScreen) =>
        prevDefaultScreen.map((item, itemIndex) =>
          itemIndex === 0 ? { ...item, footer_option: "Urdu News" } : item
        )
      );
    } else if (location?.state[0].footer_option === "RSS") {
      setDefaultScreen((prevDefaultScreen) =>
        prevDefaultScreen.map((item, itemIndex) =>
          itemIndex === 0 ? { ...item, footer_option: "RSS" } : item
        )
      );

      setFooterRssLink(location?.state[0].footer_value);
    } else if (location?.state[0].footer_option === "Text") {
      setDefaultScreen((prevDefaultScreen) =>
        prevDefaultScreen.map((item, itemIndex) =>
          itemIndex === 0 ? { ...item, footer_option: "Text" } : item
        )
      );

      setFooterText(location?.state[0].footer_value);
    } else {
      setDefaultScreen((prevDefaultScreen) =>
        prevDefaultScreen.map((item, itemIndex) =>
          itemIndex === 0 ? { ...item, footer_option: "none" } : item
        )
      );
    }
  };
  const handleNewOrder = useCallback(
    async (e, index) => {
      setShowRefreshScreen(true);
      const formObj = new FormData();
      formObj.append(
        "txt_customer_id",
        localStorage.getItem("txt_customer_id")
      );
      formObj.append("security_token", await GetCookie("es_token"));
      let associd = "";
      if (Number.isInteger(index) && index >= 0 && index < mediaForCurrentScreen.length
      ) {
          associd =  mediaForCurrentScreen[index].ser_assoc_id;
      }
      formObj.append("ser_assoc_id", associd);
      formObj.append("ser_screen_id", defaultScreen[0].value);
      formObj.append("txt_order_no", e[0].value);

      try {
        const returned = await ChangeOrder(formObj).unwrap();
        
        if (
          returned.connection === "true" &&
          returned.message === "Order changed successfully" &&
          returned.status === "true"
        ) {
          toast.success(returned.message);
          getMediaOfCurrentScreen();
        } else {
          toast.error(returned.message);
        }
      } catch (error) {
        console.log(error);
        toast.error(error.status);
      }
    },
    [ChangeOrder, defaultScreen, mediaForCurrentScreen]
  );

  // post deletion
  const handleDeletePost = (pid) => {
    swal({
      title: "Delete Post!",
      text: "Once Deleted, you will not be able to recover this post again!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (willUnLink) => {
      if (willUnLink) {
        try {
          const data = new FormData();
          data.append(
            "txt_customer_id",
            localStorage.getItem("txt_customer_id")
          );
          data.append("security_token", await GetCookie("es_token"));
          data.append("ser_post_id", pid);

          const res = await deletePost(data).unwrap();
          if (
            res.status === "true" &&
            res.message === "Post deleted successfully" &&
            res.connection === "true"
          ) {
            toast.success(res.message);
            getAllPosts(defaultScreen);
            setAnchorEl(null);
          } else {
            toast.error(res.message);
          }
        } catch (error) {
          console.log(error);
          toast.error(error.status);
        }
      }
    });
  };

  // post deletion
  const handleDeleteMedia = async (e, index) => {
    //SSBR
    let mediaToUpdate = "";
    if (Number.isInteger(index) && index >= 0 && index < mediaForCurrentScreen.length
      ) {
          mediaToUpdate = mediaForCurrentScreen[index];
      }

    setShowRefreshScreen(true);
    swal({
      title: "Remove Media!",
      text: "Are you sure you want to remove the media from this screen?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (willUnLink) => {
      if (willUnLink) {
        try {
          const data = new FormData();
          data.append(
            "txt_customer_id",
            localStorage.getItem("txt_customer_id")
          );
          data.append("security_token", await GetCookie("es_token"));
          data.append("ser_assoc_id", mediaToUpdate.ser_assoc_id);

          const res = await deleteMedia(data).unwrap();
          if (
            res.status === "true" &&
            res.message === "Media deleted successfully" &&
            res.connection === "true"
          ) {
            toast.success(res.message);
            getMediaOfCurrentScreen();
            setAnchorEl(null);
          } else {
            toast.error(res.message);
          }
        } catch (error) {
          console.log(error);
          toast.error(error.status);
        }
      }
    });
  };

  //this function will change the post order
  const handleChangePostStatus = async (e, index) => {
    try {
      setShowRefreshScreen(true);
      // SSBR
      let mediaToUpdate = "";
      if (Number.isInteger(index) && index >= 0 && index < mediaForCurrentScreen.length
      ) {
          mediaToUpdate = mediaForCurrentScreen[index];
      }
      const payload = new FormData();
      payload.append(
        "txt_customer_id",
        localStorage.getItem("txt_customer_id")
      );
      payload.append("security_token", await GetCookie("es_token"));
      payload.append("post_status", !mediaToUpdate.post_status);
      payload.append("ser_assoc_id", mediaToUpdate.ser_assoc_id);

      const res = await screenPostStatusChange(payload).unwrap();
     
      if (
        res.connection === "true" &&
        res.status === "true" &&
        res.message === "Post status updated successfully"
      ) {
        toast.success(res.message);
        getMediaOfCurrentScreen();
      } else if (res.connection === "true" && res.status === "false") {
        toast.info(res.message);
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleDurationChange = async (e, index) => {
    try {
      setShowRefreshScreen(true);
      //SSBR
      let mediaToUpdate = "";
      if (Number.isInteger(index) && index >= 0 && index < mediaForCurrentScreen.length
      ) {
          mediaToUpdate = mediaForCurrentScreen[index];
      }
      const payload = new FormData();
      payload.append(
        "txt_customer_id",
        localStorage.getItem("txt_customer_id")
      );
      payload.append("security_token", await GetCookie("es_token"));
      payload.append("image_post_duration", e.value);
      payload.append("ser_assoc_id", mediaToUpdate.ser_assoc_id);

      const res = await updateMediaDuration(payload).unwrap();
      
      if (
        res.connection === "true" &&
        res.status === "true" &&
        res.message === "Timer updated successfully"
      ) {
        toast.success(res.message);
        getMediaOfCurrentScreen();
      } else if (res.connection === "true" && res.status === "false") {
        toast.info(res.message);
      } else {
        toast.error(res.message);
      }
    } catch (error) {}
  };

  //add new post button click
  const addnewpost = () => {
    setOpenAddPostDialog(true);
    setShowRefreshScreen(true);
  };

  const playpost = (post) => {
    setdata({
      ...data,
      playingpost: true,
      selectedpost: post,
    });
  };

  const closeVideo = () => {
    setdata({
      ...data,
      playingpost: false,
      selectedpost: null,
    });
  };
  const handleSchduleModal = (media) => {
    setShowRefreshScreen(true);
    setdata({
      ...data,
      selectedpost: media,
      screenwisePostStatuscomponent: true,
    });
  };
  const handleSchduleModalClose = () => {
    setdata({
      ...data,
      selectedpost: null,
      screenwisePostStatuscomponent: false,
    });

    getMediaOfCurrentScreen();
  };

  const handleRefreshScreen = () => {
    swal({
      title: "Refresh Screen!",
      text: "This will just refresh the screen nothing with lose!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (willUnLink) => {
      if (willUnLink) {
        const payload = new FormData();
        payload.append(
          "txt_customer_id",
          localStorage.getItem("txt_customer_id")
        );
        payload.append("security_token", await GetCookie("es_token"));
        payload.append("ser_screen_id", currentScreen[0].value);

        const res = await refreshScreen(payload).unwrap();
        if (
          res.connection === "true" &&
          res.status === "true" &&
          res.message === "Screen refreshed automatically"
        ) {
          toast.success(res.message);
        } else {
          toast.error(res.message);
        }
        setAnchorEl(null);
      } else {
        setAnchorEl(null);
      }
    });
  };

  const GotoEditPostPage = (post) => {
    navigate("/editPost", { state: post });
  };

  const hideDialog = () => {
    setOpenAddPostDialog(false);
    getMediaOfCurrentScreen();
  };

  async function hideDialogAndCreatePost() {
    const createPostFormData = new FormData();
    createPostFormData.append(
      "txt_customer_id",
      localStorage.getItem("txt_customer_id")
    );
    createPostFormData.append("security_token", await GetCookie("es_token"));
    createPostFormData.append("post_type", postData.finalfile.type);
    createPostFormData.append("txt_post_status", postData.PostStatus);
    createPostFormData.append("ser_media_id", postData.finalfile.ser_media_id);
    createPostFormData.append("ser_screen_id", currentScreen[0].value);
    createPostFormData.append(
      "image_post_duration",
      postData.finalfile.type === "Image" ? "30000" : "N/A"
    );
    CreatePost(createPostFormData);
  }

  const CreatePost = async (createPostdata) => {
    try {
      const response = await createPostForSingleScreen(createPostdata).unwrap();
      if (
        response.message === "Post saved successfully" &&
        response.connection === "true" &&
        response.status === "true"
      ) {
        hideDialog();
        toast.success(response.message);

      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.error(error);
      toast.error(error.error);
    }
  };
  const handleChangefinalfile = (value) => {
    setPostdata({
      ...postData,
      finalfile: value,
    });
  };
  const mediaselectionfooter = (
    <React.Fragment>
      <Button
        variant="contained"
        className="mt-3 capitalized fs-14 fw-bold"
        onClick={hideDialogAndCreatePost}
      >
        Submit
      </Button>
    </React.Fragment>
  );

  const getNewsTextForPreview = async (footer_key, openLivePreview) => {
    var returnValue = "";
    try {
      const formData = new FormData();
      formData.append(
        "txt_customer_id",
        localStorage.getItem("txt_customer_id")
      );
      formData.append("security_token", await GetCookie("es_token"));
      formData.append("footer_key", footer_key);

      const res = await getSelectiveNews(formData).unwrap();

      if (
        res.status === "true" &&
        res.message === "News available" &&
        res.connection === "true"
      ) {
        if (!openLivePreview) {
          returnValue = res.data;
        } else {
          setMarqueeText(res.data);
          setOpenLiveView(true);
          toast.success(res.message);
        }
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(error.status);
    }

    return returnValue;
  };

  const handleLiveView = () => {
    if (
      defaultScreen[0]?.footer_option === "News" ||
      defaultScreen[0]?.footer_option === "Urdu News" ||
      defaultScreen[0]?.footer_option === "English News" ||
      defaultScreen[0]?.footer_option === "Cricinfo"
    ) {
      getNewsTextForPreview(defaultScreen[0]?.footer_option, true);
    } else if (defaultScreen[0]?.footer_option === "RSS") {
      
      getRssNewsForPreview(defaultScreen[0]?.footer_value, true);
    } else if (defaultScreen[0]?.footer_option === "Text") {
      const textObjForMarquee = [
        { txt_news_title: footerText },
      ];
      setMarqueeText(textObjForMarquee);
      setOpenLiveView(true);
    }
  };

  const getRssNewsForPreview = async (footer_value, openLivePreview) => {
    var returnValue = "";
    try {
      const formData = new FormData();

      formData.append("txt_rss_link", footerRssLink);

      const res = await getRSSNews(formData).unwrap();
      if (res.status === "true" && res.message === "Rss data available") {
        if (!openLivePreview) {
          returnValue = res.data;
        } else {
          setMarqueeText(res.data);
          setOpenLiveView(true);
          toast.success(res.message);
        }
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(error.status);
    }
    return returnValue;
  };
  
  const handleMediaAsOffline = async (media) => {
    try {
      const payload = new FormData();
      payload.append(
        "txt_customer_id",
        localStorage.getItem("txt_customer_id")
      );
      console.log(media);
      payload.append("security_token", await GetCookie("es_token"));
      payload.append("ser_media_id", media.finalfile.ser_media_id);
      payload.append("ser_assoc_id", media.ser_assoc_id);
      payload.append("ser_screen_id", media.ser_screen_id);
      payload.append("txt_media_offline_status", media.is_offline_available=='true'?'false':'true');

      const res = await addMediatoAsOffline(payload).unwrap();
      if (res.connection === "true" && res.status === "true") {
        toast.success(res.message);
        getMediaOfCurrentScreen();
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(error.status);
    }
  };
  
  const handlePreviewClick = async (index) => {
    
    var footer_value = "";
    if (
      defaultScreen[0]?.footer_option === "News" ||
      defaultScreen[0]?.footer_option === "Cricinfo"
    ) {
      footer_value = await getNewsTextForPreview(
        defaultScreen[0]?.footer_option,
        false
      );
    } else if (defaultScreen[0]?.footer_option === "RSS") {
      // call api for RSS

      footer_value = await getRssNewsForPreview(
        defaultScreen[0]?.footer_value,
        false
      );
    } else if (defaultScreen[0]?.footer_option === "Text") {
      footer_value = defaultScreen[0]?.footer_value;
    }

    var temp = [...mediaForCurrentScreen]; // Shallow copy
    //SSBR
    let deepCopy = null;

      if (
        Array.isArray(temp) &&
        Number.isInteger(index) &&
        index >= 0 &&
        index < temp.length &&
        typeof temp[index] === 'object' &&
        temp[index] !== null
      ) {
        try {
          deepCopy = JSON.parse(JSON.stringify(temp[index]));
        } catch (err) {
          console.error("Deep copy failed:", err);
        }
      }

    deepCopy.footer_value = footer_value;
    
    var layput_id;

    if (footer_value === "") {
      layput_id = "1";
    } else {
      layput_id = "2";
    }
    let mediagroupindex = null;
    if (Number.isInteger(index) && index >= 0 && index < mediaForCurrentScreen.length) {
      mediagroupindex = mediaForCurrentScreen[index];
    }

    const navigationState = {
     
      media: mediagroupindex, 
      ser_layout_id: layput_id,
      from: "newMediaScreen",
      currentScreen: currentScreen,
      footer: footer_value,
    };

    navigate("/layoutpreview", { state: navigationState });
  };
  const updatePostStatus = (index) => {
    var temp = [...mediaForCurrentScreen]; // Shallow copy
    
    const deepCopy = "";
    if (
        Array.isArray(temp) &&
        Number.isInteger(index) &&
        index >= 0 &&
        index < temp.length &&
        typeof temp[index] === 'object' &&
        temp[index] !== null &&
        'post_status' in temp[index]
      ) {
        try {
          deepCopy = JSON.parse(JSON.stringify(temp[index]));
          deepCopy.post_status = !deepCopy.post_status;
          temp[index] = deepCopy;
        } catch (err) {
          console.error("Error deep copying temp[index]:", err);
        }
      }

    setMediaForCurrentScreen([...temp]);
  };

  function sizeFormat (bytes) {
    const kb = 1024;
    const mb = kb * 1024;
    const gb = mb * 1024;
    const tb = gb * 1024;
  
    if (bytes >= 0 && bytes < kb) {
      return `${bytes}B`;
    } else if (bytes >= kb && bytes < mb) {
      return `${Math.ceil(bytes / kb)}KB`;
    } else if (bytes >= mb && bytes < gb) {
      return `${Math.ceil(bytes / mb)}MB`;
    } else if (bytes >= gb && bytes < tb) {
      return `${Math.ceil(bytes / gb)}GB`;
    } else if (bytes >= tb) {
      return `${Math.ceil(bytes / tb)}TB`;
    } else {
      return `${bytes}B`;
    }
  };
 
  return (
    <>
      {isLoading ||
      loading ||
      changeorderloading ||
      deleteloading || loading2 
      ? (
        <LoadingSpinner />
      ) : null}

      <Box sx={{ flexGrow: 1, mr: 3, mt: 1 }}>
        <div className="row  mt-4 mb-4 no-gutters">
          <div
            className="col d-flex "
            style={{ backgroundColor: "", alignItems: "center" }}
          >
            <IconButton>
              <ArrowBackIcon
                fontSize="medium"
                style={{ color: "black" }}
                onClick={() => {
                  navigate("/screens");
                }}
              />
            </IconButton>
            <h4 style={{ margin: 0 }}>
              <b>{currentScreen[0].label}</b>
            </h4>
          </div>
          <div
            className="col col-sm-6 col-md-6 col-lg-6 d-flex justify-content-end"
            style={{ backgroundColor: "" }}
          >
            {showRefershScreen ? (
              <Button
                variant="outlined"
                sx={{
                  maxHeight: "40px",
                  fontWeight: "bold",
                  textTransform: "none",
                }}
                onClick={handleRefreshScreen}
                className="mr-1 capitalized fs-14 fw-bold"
              >
                Refresh Screen
              </Button>
            ) : null}

            <Button
              variant="contained"
              sx={{
                maxHeight: "40px",
                fontWeight: "bold",
                textTransform: "none",
              }}
              onClick={addnewpost}
              className="mr-1 capitalized fs-14 fw-bold"
            >
              Add Media
            </Button>
          </div>
        </div>
        {Loading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100vh",
            }}
          >
            <LoadingSpinner />
          </Box>
        ) : mediaForCurrentScreen && mediaForCurrentScreen != null ? (
          <>
            <Box sx={{ flexGrow: 1 }}>
              <Grid
                container
                spacing={0}
                className="flex justify-content-between align-items-center"
              >
                <Grid
                  item
                  xs={8}
                  md={12}
                  lg={12}
                  className="surface-0 shadow-2 p-3 mr-2 ml-2"
                  style={{ borderRadius: "8px" }}
                >
                  <div className="row justify-content-between no-gutters ml-1 mr-1">
                    <div className="col col-sm-6 col-md-6 col-lg-6 ">
                      <h5 style={{ color: "grey" }}>
                        <b>Media</b>
                      </h5>
                    </div>
                  </div>

                  <div className="shadow-4 rounded-1 overflow-hidden">
                    <table className="table align-middle bg-white">
                      <thead className="bg-light">
                        <tr>
                          <th
                            style={{
                              backgroundColor: "#1A75E8",
                              color: "white",
                              alignItems: "center",
                              textAlign: "center",
                            }}
                          >
                            Preview
                          </th>
                          <th
                            style={{
                              backgroundColor: "#1A75E8",
                              color: "white",
                              alignItems: "center",
                              textAlign: "center",
                            }}
                          >
                            File Size
                          </th>
                          <th
                            style={{
                              backgroundColor: "#1A75E8",
                              color: "white",
                              alignItems: "center",
                              textAlign: "center",
                            }}
                          >
                            Sequence
                          </th>
                          <th
                            style={{
                              backgroundColor: "#1A75E8",
                              color: "white",
                              alignItems: "center",
                              textAlign: "center",
                            }}
                          >
                            Display
                          </th>
                          <th
                            style={{
                              backgroundColor: "#1A75E8",
                              color: "white",
                              alignItems: "center",
                              textAlign: "center",
                            }}
                          >
                            Offline
                          </th>
                          <th
                            style={{
                              backgroundColor: "#1A75E8",
                              color: "white",
                              alignItems: "center",
                              textAlign: "center",
                            }}
                          >
                            Duration
                          </th>

                          <th
                            style={{
                              backgroundColor: "#1A75E8",
                              color: "white",
                              alignItems: "center",
                              textAlign: "center",
                            }}
                          >
                            Schedule
                          </th>
                          <th
                            style={{
                              backgroundColor: "#1A75E8",
                              color: "white",
                              alignItems: "center",
                              textAlign: "center",
                            }}
                          >
                            Delete
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {mediaForCurrentScreen &&
                          mediaForCurrentScreen.map((currentRow, index) => (
                            <tr key={currentRow.ser_assoc_id}>
                              <td
                                style={{
                                  width: "20%",
                                  alignItems: "center",
                                  textAlign: "center",
                                }}
                              >
                                <div
                                  onClick={() => {
                                    handlePreviewClick(index);
                                  }}
                                >
                                  <ImageLazyLoading
                                    src={
                                      currentRow.finalfile
                                        .txt_media_file_type === "Video"
                                        ? currentRow.base64_media_thumbnail
                                        : currentRow.finalfile
                                            .txt_media_streaming_link
                                    }
                                    alt={"img"}
                                    width={"135px"}
                                    height={"75px"}
                                    style={{
                                      borderRadius: "8px",
                                      border: "3px solid #F0F0F0",
                                    }}
                                  />
                                </div>
                              </td>
                              <td
                                style={{
                                  width: "24%",
                                  alignItems: "center",
                                  textAlign: "center",
                                  wordBreak:"break-word"
                                }}
                              >
                                <h6>{sizeFormat(currentRow.media_size)}</h6>
                              </td>
                              <td
                                style={{
                                  width: "20%",
                                  alignItems: "center",
                                  textAlign: "center",
                                }}
                              >
                                <Select
                                  isMulti="true"
                                  options={options}
                                  value={currentRow.order_no}
                                  onChange={(e) => {
                                    handleNewOrder(e, index);
                                  }}
                                  isClearable={true}
                                  placeholder={currentRow.order_no}
                                  menuPortalTarget={document.body}
                                  menuPosition="fixed"
                                />
                              </td>

                              <td
                                style={{
                                  width: "10%",
                                  alignItems: "center",
                                  textAlign: "center",
                                }}
                              >
                                <Switch
                                  checked={currentRow.post_status}
                                  inputProps={{ "aria-label": "controlled" }}
                                  onChange={(e) => {
                                    handleChangePostStatus(e, index);
                                  }}
                                />
                              </td>
                              <td
                                style={{
                                  width: "10%",
                                  alignItems: "center",
                                  textAlign: "center",
                                }}
                              >
                                <Switch
                                  checked={currentRow.is_offline_available=='true'?true:false}
                                  inputProps={{ "aria-label": "controlled" }}
                                  onChange={(e) => {
                                    handleMediaAsOffline(currentRow);
                                  }}
                                />
                              </td>
                              <td
                                style={{
                                  width: "20%",
                                  alignItems: "center",
                                  textAlign: "center",
                                }}
                              >
                                <div>
                                  <Select
                                    isDisabled={
                                      currentRow.finalfile
                                        .txt_media_file_type === "Image"
                                        ? false
                                        : true
                                    }
                                    options={durationOptions}
                                    value={durationOptions.find(
                                      (option) =>
                                        option.value ===
                                        currentRow.image_post_duration
                                    )}
                                
                                    onChange={(e) => {
                                      handleDurationChange(e, index);
                                    }}
                                    isClearable={true}
                                    placeholder={currentRow.image_post_duration}
                                    menuPortalTarget={document.body}
                                    menuPosition="fixed"
                                  />
                                </div>
                               
                              </td>

                              <td
                                style={{
                                  width: "20%",
                                  alignItems: "center",
                                  textAlign: "center",
                                }}
                              >
                                <IconButton>
                                  <AccessTimeFilledIcon
                                    onClick={() =>
                                      handleSchduleModal(currentRow)
                                    }
                                    color={
                                      currentRow.is_scheduled == true
                                        ? "primary"
                                        : "action"
                                    }
                                  />
                                </IconButton>
                                
                              </td>
                              <td
                                style={{
                                  width: "20%",
                                  alignItems: "center",
                                  textAlign: "center",
                                }}
                              >
                                <IconButton>
                                  <DeleteIcon
                                    onClick={(e) => handleDeleteMedia(e, index)}
                                    sx={{ color: red[900] }}
                                  />
                                </IconButton>

                                
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </Grid>
              </Grid>
            </Box>

            <Box sx={{ flexGrow: 1 }}>
              <Grid
                container
                spacing={0}
                className="flex justify-content-between align-items-center mt-3 mb-6"
              >
                <Grid
                  item
                  xs={8}
                  md={12}
                  lg={12}
                  className="surface-0 shadow-2 p-3 mr-2 ml-2 mb-4"
                  style={{ borderRadius: "8px" }}
                >
                  <div className="row justify-content-between no-gutters ml-1 mr-1">
                    <div className="col col-sm-6 col-md-6 col-lg-6 ">
                      <h5 style={{ color: "grey" }}>
                        <b>Add Footer</b>
                      </h5>
                    </div>
                  </div>

                  <div className="row justify-content-between no-gutters ml-1 mr-1">
                    <div className="col col-sm-6 col-md-6 col-lg-6 ">
                      <FormControl component="fieldset">
                        <RadioGroup
                          row
                          aria-labelledby="demo-row-radio-buttons-group-label"
                          name="row-radio-buttons-group"
                          value={
                            defaultScreen[0]?.footer_option == null
                              ? "none"
                              : defaultScreen[0]?.footer_option
                          } //selectedFooterSource
                          onChange={(e) => {
                           

                            setDefaultScreen((prevDefaultScreen) =>
                              prevDefaultScreen.map((item, itemIndex) =>
                                itemIndex === 0
                                  ? { ...item, footer_option: e.target.value }
                                  : item
                              )
                            );

                          }}
                        >
                          
                          <FormControlLabel
                            value="Urdu News"
                            control={<Radio />}
                            label="Urdu News"
                          />
                          <FormControlLabel
                            value="English News"
                            control={<Radio />}
                            label="English News"
                          />
                          <FormControlLabel
                            hidden="true"
                            value="Cricinfo"
                            control={<Radio />}
                            label="Cricinfo"
                          />
                          <FormControlLabel
                            value="Text"
                            control={<Radio />}
                            label="Text"
                          />
                          
                          <FormControlLabel
                            value="none"
                            control={<Radio />}
                            label="None"
                          />
                          {defaultScreen[0]?.footer_option === "none" ? null : (
                            <Button
                              onClick={() => {
                                handleLiveView();
                              }}
                              className="capitalized fs-14 fw-bold"
                            >
                              Live View
                            </Button>
                          )}
                        </RadioGroup>
                      </FormControl>
                    </div>

                    <div className="col col-sm-6 col-md-6 col-lg-6 ">
                      <Button
                      className="capitalized fs-14 fw-bold"
                        style={{
                          float: "right",
                          maxHeight: "40px",
                          fontWeight: "bold",
                          textTransform: "none",
                        }}
                        color="primary"
                        variant="contained"
                        onClick={() => {
                          handleUpdateScreenFooterOption(
                            defaultScreen[0].footer_option,
                            footerRssLink,
                            footerText
                          );
                        }}
                      >
                        Update Footer
                      </Button>
                    </div>
                  </div>

                  <div col col-sm-6 col-md-6 col-lg-6>
                    {data.PostWidget === "GenericDescription" ? (
                      <div className="form-group col-md-6 mt-3">
                        <label htmlFor="inputEmail4">
                          Footer Generic Description
                        </label>
                        <textarea
                          value={data.GenericDescription}
                        
                          style={{ overflow: "hidden" }}
                        />
                      </div>
                    ) : defaultScreen[0].footer_option === "RSS" ? (
                      <div className="form-group col-md-6 mt-3">
                        <label htmlFor="inputEmail4">Footer RSS Link</label>
                        <textarea
                          value={footerRssLink}
                          name="footer_widget_rss_link"
                          

                          onChange={
                            (e) => {
                              setFooterRssLink(e.target.value);
                            }

                          }
                          style={{ overflow: "hidden" }}
                        />
                      </div>
                    ) : defaultScreen[0].footer_option === "Text" ? (
                      <div className="form-group col-md-6 mt-3">
                        <label htmlFor="inputEmail4">Footer Text</label>
                        <textarea
                          value={footerText}
                          name="footer_widget_text"
                          onChange={
                            (e) => setFooterText(e.target.value)
                        
                          }
                          style={{ overflow: "hidden" }}
                        />
                      </div>
                    ) : defaultScreen[0].footer_option === "Newss" ? (
                      <FormControl component="fieldset">
                        <FormGroup aria-label="position" row>
                          <Select
                            
                            onChange={(e) => {
                              
                            }}
                            onClose={() => {
                              toast.error("close");
                            }}
                            name="footer_body_news_option_name"
                            isClearable={true}
                            placeholder="News options"
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                            isMulti="true"
                            styles={{
                              menuPortal: (provided) => ({
                                ...provided,
                                zIndex: 9999,
                              }),
                              menu: (provided) => ({
                                ...provided,
                                zIndex: 9999,
                              }),
                            }}
                          />
                        </FormGroup>
                      </FormControl>
                    ) : null}
                  </div>
                </Grid>
              </Grid>
            </Box>
            <StyledMenu
              id="demo-customized-menu"
              MenuListProps={{
                "aria-labelledby": "demo-customized-button",
              }}
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
            >
              {defaultScreen?.length === 1 ? (
                <MenuItem
                  disableRipple
                  onClick={() => handleDeletePost(clickedPost)}
                >
                  <DeleteForeverIcon />
                  Delete Post
                </MenuItem>
              ) : null}
            </StyledMenu>
          </>
        ) : (
          <div className="col d-flex justify-content-center">
            <img
              style={{ maxWidth: "600px", minWidth: "200px", width: "100%" }}
              src={add_media_image}
              alt="No media"
            />
          </div>
        )}

        <Dialog
          visible={openAddpostDialog}
          style={{ width: "1200px", height: "600px" }}
          breakpoints={{ "960px": "75vw", "640px": "100vw" }}
          header={"Select Media"}
          modal
          maximizable={true}
          footer={mediaselectionfooter}
          onHide={hideDialog}
        >
          <ChooseMedia
            setfinalfile={handleChangefinalfile}
            finalfile={postData.finalfile}
          />
        </Dialog>
      </Box>
      {/* ) : (
     <> */}

      {/* </>)} */}

      <Modal
        open={data?.playingpost}
        onClose={closeVideo}
        classNames={{
          overlayAnimationIn: "customEnterOverlayAnimation",
          overlayAnimationOut: "customLeaveOverlayAnimation",
          modalAnimationIn: "customEnterModalAnimation",
          modalAnimationOut: "customLeaveModalAnimation",
        }}
        animationDuration={800}
        styles={{
          modal: {
            width: "90%",
            height: "65vh",
            padding: "unset",
            overflow: "hidden",
          },
          overlay: {
            background: "rgba(0, 0, 0, 0.5)",
          },
          closeButton: {
            background: "yellow",
          },
        }}
        center
      >
        <PostPlaying post={data?.selectedpost} />
      </Modal>

      <Modal
        open={openLiveView}
        onClose={() => {
          setOpenLiveView(false);
        }}
        classNames={{
          overlayAnimationIn: "customEnterOverlayAnimation",
          overlayAnimationOut: "customLeaveOverlayAnimation",
          modalAnimationIn: "customEnterModalAnimation",
          modalAnimationOut: "customLeaveModalAnimation",
        }}
        animationDuration={800}
        styles={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",

          modal: {
            width: "90%",
            height: "15%",
            padding: "unset",
            overflow: "hidden",
          },
          overlay: {
            background: "rgba(0, 0, 0, 0.5)",
          },
          closeButton: {
            background: "yellow",
          },
        }}
        center
      >
        <Marquee
          className="mt-6"
          speed={20}
          direction={
            defaultScreen[0]?.footer_option === "Urdu News" ? "right" : "left"
          }
        >
         
          {marqueeText.map((data) => {
            return <p>{data?.txt_news_title + "                      ."}</p>;
          })}
        </Marquee>
      </Modal>

      {data.screenwisePostStatuscomponent === true ? (
        <ScreenWisePostScheduling
          show={data?.screenwisePostStatuscomponent}
          close={handleSchduleModalClose}
          screen={defaultScreen[0].value}
          schinfo={data?.selectedpost}
          defaultScreen={defaultScreen}
        />
      ) : null}
    </>
  );
};

export default memo(NewScreenMediaMapping);
